import { render, staticRenderFns } from "./RetentionProduct.vue?vue&type=template&id=06500f38&scoped=true"
import script from "./RetentionProduct.vue?vue&type=script&lang=js"
export * from "./RetentionProduct.vue?vue&type=script&lang=js"
import style0 from "./RetentionProduct.vue?vue&type=style&index=0&id=06500f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06500f38",
  null
  
)

export default component.exports